import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import localizationService from "../../services/localization-service";
import MoonLoader from "react-spinners/MoonLoader";
import DOMPurify from "dompurify";

export const TermsOfUsePublic = () => {
  const selectedlang = useSelector((state) => state.account.lang);
  const rawTermsOfUseTextHtml = localizationService.getLocalizationValue(
    "termsOfUseText",
    selectedlang,
  );
  const safeTermsOfUseTextHtml = DOMPurify.sanitize(rawTermsOfUseTextHtml, {
    ADD_ATTR: ["target"],
  }); // remove ANY unsafe content
  const [isDesktopResolution, setIsDesktopResolution] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (window.innerWidth < 500) {
      setIsDesktopResolution(false);
      document.body.classList.remove("bg-gray-50");
      document.body.classList.add("bg-white", "pt-6", "pb-5");
    }
    setIsLoading(false);
  }, []);

  return (
    <React.Fragment>
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 transition-opacity duration-300">
          <MoonLoader
            color="#9aa82d"
            size={80}
            loading={isLoading}
            aria-label="Loading Spinner"
          />
        </div>
      )}

      <div
        className={`terms-of-use-page bg-white ${
          isDesktopResolution ? "rounded-2xl shadow-xl p-8 mb-10" : "px-1"
        }`}
      >
        <h1 className="terms-of-use-title my-[20px]">
          {localizationService.getLocalizationValue(
            "termsOfUseTitle",
            selectedlang,
          )}
        </h1>
        <div
          dangerouslySetInnerHTML={{
            __html: safeTermsOfUseTextHtml,
          }}
        ></div>
      </div>
    </React.Fragment>
  );
};
